<div (click)="columnClick($event)" class="eFormColumn"  [ngStyle]="{'width': column.FixedWidth ? column.Width + 'px' : ''}"
  [ngClass]="{'selected': isSelected || isDragging, 'allowEdit': !hideEditHeader && !isDragging}">
  <div class="editHeader" *ngIf="!isDragging && !hideEditHeader"
    [ngClass]="{'editClick': isSelected, 'hidden': !isSelected}">
    <div style="flex:1;">
      <ng-content></ng-content>
    </div>
    <div>
      <!-- <button mat-icon-button (click)="editClick()"><img id='imgEdit' alt='Edit Column' aria-label='Edit Column'
          src='./assets/images/edit disabled.png' /></button> -->
      <button mat-icon-button (click)="copyClick()"><img id='imgCopy' alt='Copy Element' *ngIf="!config.IsMobile"
          style="height: 25px; width: 25px;" aria-label='Copy Element'
          src='./assets/images/Google content-copy icon.png' /></button>

      <button mat-icon-button (click)="deleteClick()"><img id='imgDelete' alt='Remove Element' [ngStyle]="{'margin-bottom': config.IsMobile ? '25px' : '0px' }" 
          aria-label='Remove Element' src='./assets/images/trash disabled.png' /></button> 
    </div>
  </div>
  <div *ngIf="column.Rows && column.Rows.length > 0" cdkDropList class="dropList" [cdkDropListData]="column.Rows"
    [cdkDropListEnterPredicate]="rowPredicate" (cdkDropListDropped)="rowDropped($event)" [ngStyle]="{'padding-left': column.Indent + 'px'}">
    <e-form-row *ngFor="let row of column.Rows; let i = index; trackBy: getRowId" [row]="row" cdkDragLockAxis="y"
      cdkDrag class="dropItem" cdkDragBoundary=".dropList" [ngStyle]="{'min-height': (row.Height + 'px')}"
      (cdkDragStarted)="dragStart()" (cdkDragEnded)="dragEnd()"  [config]="config">
      <button mat-icon-button cdkDragHandle style="cursor:move;"> 
        <img id='imgGrip' alt='Drag to Reorder' aria-label='Drag to Reorder' src='./assets/images/grip.png' />
      </button>
    </e-form-row>
  </div>
  <ng-container *ngIf="!column.Rows || column.Rows.length == 0">
    <div *ngIf="column.Controls && column.Controls.length > 0" class="dropList eFormColumn" cdkDropList
      [ngStyle]="{'align-items': column.Alignment}" [cdkDropListData]="column.Controls"
      (cdkDropListDropped)="controlDropped($event)" style="flex:1;" #controlList
      [cdkDropListConnectedTo]="connectedDropLists" [ngStyle]="{'padding-left': column.Indent + 'px'}">
      <e-form-control class="dropItem" *ngFor="let control of column.Controls;trackBy: getControlId" [control]="control"
        cdkDrag [cdkDragData]="column" (cdkDragStarted)="dragStart()" (cdkDragEnded)="dragEnd()"
        style="padding:0px 5px" [config]="config" [ngStyle]="{'min-width': control.ControlType == 'component' ? '' : control.Width, 'height': control.ControlType == 'verticalDivider' ? control.Height: ''}">
        <button mat-icon-button cdkDragHandle style="cursor:move;"><img id='imgGrip' alt='Drag to Reorder'
            aria-label='Drag to Reorder' src='./assets/images/grip.png' /></button>
      </e-form-control>
    </div>
    <div *ngIf="!column.Controls || column.Controls.length == 0" class="dropHere dropList" cdkDropList
      style="height:100%;" [cdkDropListData]="column.Controls" (cdkDropListDropped)="controlDropped($event)"
      #controlList [cdkDropListConnectedTo]="connectedDropLists">
      Column - Drop Controls Here
    </div>
  </ng-container>

</div>
